(function () {
  const PRODUCTS_TARGET_ID = 'CollectionProducts';

  function getScrollOffset() {
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    return (Number.isNaN(headerHeight) ? 80 : headerHeight) + 16;
  }

  function scrollToProducts() {
    const target = document.getElementById(PRODUCTS_TARGET_ID);
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function bindScrollTrigger(element) {
    element.addEventListener('click', scrollToProducts);
    element.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scrollToProducts();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-scroll-to-products]').forEach(bindScrollTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
